import { usePostMutation } from "@/api/swr/useMutation";
import { loginResSchema, loginSchema } from "@/schema/app/Login";

type Config = Parameters<
  typeof usePostMutation<typeof loginSchema, typeof loginResSchema>
>[3];

export const useLogin = (config: Config) => {
  return usePostMutation(loginSchema, loginResSchema, "/app/login", config);
};
